<div class="mat-typography">
  <h1 mat-dialog-title>Existing User</h1>
  <mat-card-content class="mat-typography">
    <div [innerHtml]="data.messageToDisplay"></div>
  </mat-card-content>
</div>
